import React, { FC } from 'react';
import { formatCurrency } from '@factorin/util';

import { useTranslation } from 'Modules/core/i18n';
import { Box, Typography } from 'Modules/ui3';


type ObligationBannerProps = {
    amount: number;
};

export const ObligationBanner: FC<ObligationBannerProps> = ({ amount }) => {
    const { t } = useTranslation('ObligationBanner');

    return (
        <Box
            py={2.5}
            bgcolor='infoCustom.red10'
            textAlign='center'
        >
            <Typography
                variant='regularCaption1'
                color='infoCustom.red50'
                textAlign='center'
                whiteSpace='pre-line'
            >
                {t('text', { amount: formatCurrency(amount, '₽', 0) })}
            </Typography>
        </Box>
    );
};
